import { Box, Typography } from '@oresundsbron/bridge-ui';
import { CloseOutlined } from '@oresundsbron/icons';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

const CommercialVehicleError: FC = () => {
  const { t } = useTranslation(['error', 'common'], {
    nsMode: 'fallback',
  });

  return (
    <Box className="col-span-full flex flex-col items-center gap-4 pb-8">
      <CloseOutlined className="text-6xl text-red-400" />
      <Typography intent="headline" className="text-center">
        {t('internalError.title')}
      </Typography>
      <Typography intent="body" className="text-center">
        {t('form.validations.commercial.notAllowed')}
      </Typography>
    </Box>
  );
};

export default CommercialVehicleError;
